import styled from "@emotion/styled/macro";
import InputField from "@metacrm/metacrm-material-ui/dist/InputField";
import Box from "@mui/material/Box";
import isStyledPropsValid from "utils/isStyledPropsValid";

export const StyledHint = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme }) => ({
  borderRadius: "4px",
  border: "1px solid #7B61FF",
  background: "rgba(123, 97, 255, 0.15)",
  marginBottom: "8px",
  padding: "16px",
  display: "flex",
}));

export const StyledAiToolWhiteContainer = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme }) => ({
  borderRadius: "4px",
  boxShadow: " 0px 0px 20px 0px rgba(0, 0, 0, 0.05)",
}));

export const StyledAiSettingTitle = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme }) => ({
  color: "#555",
  fontSize: "14px",
  fontWeight: 700,
}));

export const StyledAiSettingDescription = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme }) => ({
  color: "#777",
  fontSize: "14px",
  fontWeight: 500,
}));
